const { SITE_BASE_URL } = require('./brokerConnectionSource');
const { ogImageUrlForPath } = require('./ogTitleCard');
const { NOINDEX_SITE_ROUTES, PUBLIC_SITE_ROUTES } = require('./siteRoutes');

const PAGE_MANAGED_METADATA_PATHS = new Set([
  '/',
  '/sales',
  '/marketplace',
  '/sales-marketplace',
  '/pricing',
  '/courses/ai-trading-bootcamp',
  '/courses/ai-trading-bootcamp/self-paced',
  '/live-algo-lab',
  '/upgrade-to-pro',
  '/blog',
  '/blog/using-ai-to-make-ai-profitable-swing-trading-bot-in-seconds',
  '/compare',
]);

const ROBOTS_DISALLOW_PREFIXES = Object.freeze([
  '/api/',
  '/checkout',
  '/set-password',
  '/signup-survey',
  '/auto-login-*',
  '/modal-test',
  '/onboarding',
  '/oauth/',
  '/ai-agent',
  '/dashboard',
  '/my-bots',
  '/login',
  '/account-settings',
  '/lp',
  '/add-bot',
  '/backtest',
  '/deploy',
  '/brokerage-accounts',
  '/my-backtests',
  '/my-deployments',
  '/my-strategies',
  '/my-published-strategies',
  '/user_profile',
  '/affiliate/dashboard',
]);

const ROBOTS_ALLOW_PUBLIC_PREFIXES = Object.freeze([
  '/',
  '/sales',
  '/marketplace',
  '/pricing',
  '/blog',
  '/compare',
  '/guides',
  '/brokers',
  '/courses',
  '/agents',
  '/case-studies',
]);

function normalizePathname(pathname) {
  if (!pathname) return '/';
  const value = String(pathname);
  if (value === '/') return '/';
  return value.replace(/\/+$/, '') || '/';
}

function isPageManagedMetadataPath(pathname) {
  const path = normalizePathname(pathname);
  return (
    PAGE_MANAGED_METADATA_PATHS.has(path) ||
    path.startsWith('/compare/') ||
    path === '/guides' ||
    path.startsWith('/guides/')
  );
}

function getNoindexRoute(pathname) {
  const path = normalizePathname(pathname);
  if (
    /^\/courses-clarity(?:\/|$)/.test(path) ||
    /^\/courses\/ai-trading-bootcamp\/(control|agentic)$/.test(path)
  ) {
    return {
      path,
      title: 'Bootcamp page review | BotSpot',
      description: 'Course page review.',
      robots: 'noindex, follow',
      sitemap: false,
    };
  }
  return (
    NOINDEX_SITE_ROUTES.find((route) => route.path === path) ||
    (path.startsWith('/lp/')
      ? {
          path,
          title: 'BotSpot landing page',
          description: 'Paid BotSpot landing page. This URL is not a public marketing index page.',
          robots: 'noindex, follow',
          sitemap: false,
        }
      : null)
  );
}

function isNoindexPath(pathname) {
  return Boolean(getNoindexRoute(pathname));
}

function getPublicPageSeo(pathname) {
  const path = normalizePathname(pathname);
  const route = PUBLIC_SITE_ROUTES.find((item) => item.path === path);
  if (!route) return null;
  return {
    ...route,
    canonical: `${SITE_BASE_URL}${path === '/' ? '/' : path}`,
    image: route.image || ogImageUrlForPath(path),
    robots: route.robots || 'index, follow',
    heading: route.content?.heading || route.title,
  };
}

module.exports = {
  PAGE_MANAGED_METADATA_PATHS,
  ROBOTS_ALLOW_PUBLIC_PREFIXES,
  ROBOTS_DISALLOW_PREFIXES,
  getNoindexRoute,
  getPublicPageSeo,
  isNoindexPath,
  isPageManagedMetadataPath,
  normalizePathname,
};
